import type { ReactNode } from 'react';

/** Shared instruction layout for participant and organizer roles. */
export function BoxRoleGuide({
  title,
  steps,
  testId,
}: {
  title: string;
  steps: { title: string; body: ReactNode; icon: ReactNode }[];
  testId?: string;
}) {
  return (
    <section className="box-main__guide" data-testid={testId}>
      <h2>{title}</h2>
      <ol>
        {steps.map((step) => (
          <li key={step.title}>
            <span className="box-main__step" aria-hidden="true">
              {step.icon}
            </span>
            <div>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
